import MatchCard from './MatchCard/MatchCard';
import './MatchList.css';

export default function MatchList({ matchesGroupedByGameday }) {
  return (
      <div className="spiele-page__matches" id="matches">
        {matchesGroupedByGameday.map((group) => (
          <div key={group.day} id={group.day}>
            <div className="spiele-page__gameday-header">
              <h2>{group.day}. SPIELTAG</h2>
            </div>
            {group.matches.map((match) => (
              <MatchCard
                key={match.id}
                match={match}
              />
            ))}
          </div>
        ))}
      </div>
  );
}
